import React from 'react';

import i18next from 'i18next';

import { useTheme } from '@mui/material/styles';
import { Backdrop, CircularProgress, Grid } from '@mui/material';

import ResizeHeight from './ResizeHeight';

/* eslint-disable react/require-default-props -- Optional props are expressed via TypeScript; defaults are applied in the component body. */

const loaderStyles = () => ({
  backdrop: {
    // zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  bgColor: {
    backgroundColor: '1C3443' // theme.palette.type === 'light' ? '#1C3443' : '#202129'
  }
});

export default function RfpLoader({ loading, isAbsolute }: { loading: boolean; isAbsolute?: boolean }) {
  const classes = loaderStyles();
  return (
    <div>
      <Backdrop className={`${classes.backdrop} ${isAbsolute ? 'position-absolute' : ''}`} open={loading}>
        <CircularProgress color='inherit' />
      </Backdrop>
    </div>
  );
}

type LoadingCardProps = {
  phrase: string;
  customContent?: React.ReactNode;
  width?: string;
  reSizeClassName?: string;
};

export const LoadingCard = ({ phrase, customContent, width, reSizeClassName }: LoadingCardProps) => {
  const classes = loaderStyles();
  return (
    <ResizeHeight className={reSizeClassName}>
      <Grid container justifyContent='center' alignItems='center' className='h-100p'>
        <Grid container direction='column' justifyContent='center' alignItems='center' className={`${width || 'w-200'} p-15 ${classes.bgColor} border-radius-8`}>
          <Grid item className='w-100 text-align-center'>
            <CircularProgress size={20} style={{ color: 'white' }} />
          </Grid>
          <Grid item className='font-12p fontColor'>
            {customContent || i18next.t('LOAD')} {`${i18next.t(phrase)}`}...
          </Grid>
        </Grid>
      </Grid>
    </ResizeHeight>
  );
};

export function Loading(props: { width?: number; height?: number; className?: string }) {
  const theme = useTheme();
  const { width, height, className } = props;

  return (
    <svg version='1.1' id='loader-1' x='0px' y='0px' width={width || 30} height={height || 30} className={className} viewBox='0 0 40 40' enableBackground='new 0 0 40 40'>
      <path
        opacity={theme.palette.mode === 'light' ? '0.3' : 'none'}
        fill='#000'
        d='M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
          c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z'
      />
      <path
        fill='#000'
        d='M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
          C22.32,8.481,24.301,9.057,26.013,10.047z'>
        <animateTransform attributeType='xml' attributeName='transform' type='rotate' from='0 20 20' to='360 20 20' dur='0.5s' repeatCount='indefinite' />
      </path>
    </svg>
  );
}
